module.exports = __webpack_public_path__ + "media/cheney/CheneyLogoLight-2819657d.png";